import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { BrandMark } from "@/components/BrandMark";
import { Loader2, Sparkles } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Public landing that resolves a /r/{code} short link.
 * - Tracks a click server-side (with the visitor session_id so we can
 *   credit the referrer at conversion).
 * - Shows a friendly welcome from the referrer.
 * - Redirects to /shop after a brief pause.
 */
export default function ReferralLanding() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true, referrer: null, error: null });

  useEffect(() => {
    let sid = null;
    try {
      sid = localStorage.getItem("sh_session_id");
      if (!sid) {
        sid = `sh_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
        localStorage.setItem("sh_session_id", sid);
      }
    } catch {
      sid = `sh_anon_${Math.random().toString(36).slice(2, 10)}`;
    }
    axios
      .get(`${BACKEND_URL}/api/referrals/resolve/${code}`, { params: { session_id: sid } })
      .then((r) => {
        setState({ loading: false, referrer: r.data.referrer, error: null });
        setTimeout(() => navigate("/shop", { replace: true }), 2200);
      })
      .catch(() => {
        setState({ loading: false, referrer: null, error: "Unknown referral link" });
        setTimeout(() => navigate("/shop", { replace: true }), 2200);
      });
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-4">
      <div className="max-w-md text-center space-y-6">
        <div className="flex justify-center">
          <BrandMark size={72} animated />
        </div>
        {state.loading ? (
          <div className="flex items-center justify-center gap-2 text-white/60">
            <Loader2 size={16} className="animate-spin" />
            <span className="font-mono text-xs uppercase tracking-widest">Opening the shop…</span>
          </div>
        ) : state.error ? (
          <div className="text-white/60 text-sm">Referral link not found. Taking you to the shop…</div>
        ) : (
          <>
            <div className="font-display text-3xl">
              You were invited by <span className="text-[color:var(--hq-cyan)]">{state.referrer}</span>
            </div>
            <div className="flex items-center justify-center gap-2 text-white/60 text-sm">
              <Sparkles size={14} /> Welcome to EMRKT.CH
            </div>
            <div className="font-mono text-xs uppercase tracking-widest text-white/40">
              redirecting to the shop…
            </div>
          </>
        )}
      </div>
    </div>
  );
}
